import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-instrument-template-info',
  imports: [TranslatePipe],
  templateUrl: './instrument-template-info.component.html',
  styleUrls: [
    './instrument-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class InstrumentTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'instrument.';
}
